// English
import adminVideo_en from '../messages/en/adminVideo_en.json'
import general_en from '../messages/en/general_en.json'
import legalNotice_en from '../messages/en/legalNotice_en.json'
import privacyPolicy_en from '../messages/en/privacyPolicy_en.json'
import termsOfService_en from '../messages/en/termsOfService_en.json'

const en = Object.assign({}, general_en, adminVideo_en, legalNotice_en, termsOfService_en, privacyPolicy_en)

// French
import adminVideo_fr from '../messages/fr/adminVideo_fr.json'
import general_fr from '../messages/fr/general_fr.json'
import legalNotice_fr from '../messages/fr/legalNotice_fr.json'
import privacyPolicy_fr from '../messages/fr/privacyPolicy_fr.json'
import termsOfService_fr from '../messages/fr/termsOfService_fr.json'

const fr = Object.assign({}, general_fr, adminVideo_fr, legalNotice_fr, termsOfService_fr, privacyPolicy_fr)

// Spanish
import adminVideo_es from '../messages/es/adminVideo_es.json'
import general_es from '../messages/es/general_es.json'

const es = Object.assign({}, general_es, adminVideo_es, legalNotice_en, termsOfService_en, privacyPolicy_en)

// German
import adminVideo_pl from '../messages/pl/adminVideo_pl.json'
import general_pl from '../messages/pl/general_pl.json'

const pl = Object.assign({}, general_pl, adminVideo_pl, legalNotice_en, termsOfService_en, privacyPolicy_en)

// Deutsche
import adminVideo_de from '../messages/de/adminVideo_de.json'
import general_de from '../messages/de/general_de.json'

const de = Object.assign({}, general_de, adminVideo_de, legalNotice_en, termsOfService_en, privacyPolicy_en)

// Italian
import adminVideo_it from '../messages/it/adminVideo_it.json'
import general_it from '../messages/it/general_it.json'

const it = Object.assign({}, general_it, adminVideo_it, legalNotice_en, termsOfService_en, privacyPolicy_en)

// Nezeland
import adminVideo_nl from '../messages/nl/adminVideo_nl.json'
import general_nl from '../messages/nl/general_nl.json'

const nl = Object.assign({}, general_nl, adminVideo_nl, legalNotice_en, termsOfService_en, privacyPolicy_en)

// Português
import adminVideo_pt from '../messages/pt/adminVideo_pt.json'
import general_pt from '../messages/pt/general_pt.json'

const pt = Object.assign({}, general_pt, adminVideo_pt, legalNotice_en, termsOfService_en, privacyPolicy_en)

import adminVideo_sv from '../messages/sv/adminVideo_sv.json'
import general_sv from '../messages/sv/general_sv.json'

const sv = Object.assign({}, general_sv, adminVideo_sv, legalNotice_en, termsOfService_en, privacyPolicy_en)

import adminVideo_da from '../messages/da/adminVideo_da.json'
import general_da from '../messages/da/general_da.json'

const da = Object.assign({}, general_da, adminVideo_da, legalNotice_en, termsOfService_en, privacyPolicy_en)

export default {
  en: en,
  fr: fr,
  es: es,
  pl: pl,
  de: de,
  it: it,
  nl: nl,
  pt: pt,
  sv: sv,
  da: da
}
